import React, { useEffect, useState } from 'react';
import { MenuIcon, XIcon } from 'lucide-react';
import { AnimatePresence, motion } from 'framer-motion';
import { useLanguage } from './LanguageContext';
const navLinks = [{
  label: 'Inicio',
  href: '#inicio'
}, {
  label: 'Servicios',
  href: '#servicios'
}, {
  label: 'Comparación',
  href: '#comparacion'
}, {
  label: 'Ventajas',
  href: '#ventajas'
}, {
  label: 'Proceso',
  href: '#proceso'
}, {
  label: 'Contacto',
  href: '#contacto'
}];
export function Header() {
  const [menuOpen, setMenuOpen] = useState(false);
  const {
    t
  } = useLanguage();
  const navLinks = [{
    label: t('nav.home'),
    href: '#inicio'
  }, {
    label: t('nav.services'),
    href: '#servicios'
  }, {
    label: t('nav.comparison'),
    href: '#comparacion'
  }, {
    label: t('nav.advantages'),
    href: '#ventajas'
  }, {
    label: t('nav.process'),
    href: '#proceso'
  }, {
    label: t('nav.contact'),
    href: '#contacto'
  }];
  // Close menu on resize to desktop
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 768) setMenuOpen(false);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  // Prevent body scroll when menu is open
  useEffect(() => {
    if (menuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [menuOpen]);
  const handleNavClick = () => {
    setMenuOpen(false);
  };
  return <header className="sticky top-0 z-50 w-full bg-navy-900 border-b border-steel-dark/50" data-id="element-176">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-177">
        <div className="flex items-center justify-between h-20 gap-4" data-id="element-178">
          {/* Logo */}
          <div className="flex-1 max-w-lg" data-id="element-179">
            <img className="h-16 w-full object-contain object-left" src="https://cdn.magicpatterns.com/uploads/ewmuY2XmHcFv7rR1BGg2Ew/logo_real_22.png" alt="Estructuras y Arcotechos" data-id="element-180" />
          </div>

          {/* Desktop nav */}
          <nav className="hidden md:flex items-center gap-1" data-id="element-181">
            {navLinks.map(link => <a key={link.href} href={link.href} className="px-3 py-2 text-sm font-medium text-gray-300 hover:text-amber transition-colors duration-200 rounded-md hover:bg-white/5" data-id="element-182">
                {link.label}
              </a>)}
            <a href="#contacto" className="ml-3 inline-flex items-center justify-center px-6 py-2.5 border border-transparent text-sm font-semibold rounded-md text-navy-900 bg-amber hover:bg-amber-light transition-colors duration-200 uppercase tracking-wider flex-shrink-0" data-id="element-183">
              {t('nav.cta')}
            </a>
          </nav>

          {/* Mobile: CTA + Hamburger */}
          <div className="flex md:hidden items-center gap-3" data-id="element-184">
            <a href="#contacto" className="inline-flex items-center justify-center px-4 py-2 border border-transparent text-xs font-semibold rounded-md text-navy-900 bg-amber hover:bg-amber-light transition-colors duration-200 uppercase tracking-wider flex-shrink-0" data-id="element-185">
              {t('nav.cta')}
            </a>
            <button onClick={() => setMenuOpen(!menuOpen)} className="p-2 rounded-md text-gray-300 hover:text-white hover:bg-white/10 transition-colors" aria-label={menuOpen ? t('nav.closeMenu') : t('nav.openMenu')} aria-expanded={menuOpen} data-id="element-186">
              {menuOpen ? <XIcon className="w-6 h-6" data-id="element-187" /> : <MenuIcon className="w-6 h-6" data-id="element-188" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile accordion menu */}
      <AnimatePresence data-id="element-189">
        {menuOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3,
        ease: 'easeInOut'
      }} className="md:hidden overflow-hidden bg-navy-900 border-t border-steel-dark/30" data-id="element-190">
            <nav className="px-4 py-4 space-y-1" data-id="element-191">
              {navLinks.map((link, i) => <motion.a key={link.href} href={link.href} onClick={handleNavClick} initial={{
            x: -20,
            opacity: 0
          }} animate={{
            x: 0,
            opacity: 1
          }} transition={{
            delay: i * 0.05,
            duration: 0.2
          }} className="block px-4 py-3 text-base font-medium text-gray-300 hover:text-amber hover:bg-white/5 rounded-lg transition-colors duration-200 border-b border-steel-dark/20 last:border-b-0" data-id="element-192">
                  {link.label}
                </motion.a>)}
            </nav>
          </motion.div>}
      </AnimatePresence>
    </header>;
}